import React, { useMemo, useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { formatBigNumbersToString, formatValueAsString } from '../../../../../../utils/helpers';
import { AgChartOptions } from 'ag-charts-community';
import { IVesselsMainEngineFuelConsumes } from '../../../../greenTypes';
import { CHART_COLORS } from '../../../../../../constants/constants';

interface IMainEngineFuelTypeChartProps {
	data: IVesselsMainEngineFuelConsumes[];
}

const MainEngineFuelTypeChart: React.FC<IMainEngineFuelTypeChartProps> = ({ ...props }) => {
	const formatOptions = useMemo(() => ({ minimumFractionDigits: 0, maximumFractionDigits: 2 }), []);

	const transformedData = [
		props.data.reduce(
			(acc: any, curr) => {
				acc[curr.mainEngineFuelType] = curr.mainEngineEmission;
				return acc;
			},
			{ type: 'Fuel' },
		),
	];

	const fuelTypes = Object.keys(transformedData[0]).filter((key) => key !== 'type');

	const [options] = useState<AgChartOptions>({
		data: transformedData,
		title: {
			text: 'Main Engine CO2 Emissions by Fuel Type (Tank-to-Wake)',
			textAlign: 'left',
			fontSize: 14,
			spacing: 15,
		},
		series: fuelTypes.map((fuelType, index) => ({
			type: 'bar',
			direction: 'horizontal',
			xKey: 'type',
			yKey: fuelType,
			yName: fuelType,
			stacked: true,
			fill: CHART_COLORS[index],
			label: {
				enabled: true,
				color: '#FFFFFF',
				fontWeight: 'bold',
				formatter: ({ value }: { value: number }) => `${formatValueAsString(value, formatOptions, '', '', '')}`,
			},
			tooltip: {
				renderer(params) {
					return {
						data: undefined,
						title: fuelType,
						heading: formatValueAsString(params.datum[fuelType], formatOptions, '', '', ''),
					};
				},
			},
		})),
		legend: {
			position: 'top',
			spacing: 15,
			item: {
				// label: {
				// 	fontSize: 10,
				// },
				marker: {
					shape: 'circle',
					size: 10,
				},
			},
		},
		axes: [
			{
				type: 'category',
				position: 'left',
				label: {
					enabled: false,
				},
			},
			{
				type: 'number',
				position: 'bottom',
				label: {
					formatter: ({ value }: { value: number }) => {
						return formatBigNumbersToString(value);
					},
				},
				nice: false,
			},
		],
		padding: { top: 0, bottom: 0, left: 5, right: 10 },
	});

	return <AgCharts options={options} className="w-full h-full" style={{ height: '140px' }} />;
};

export default MainEngineFuelTypeChart;
